import item01 from '../image/muscle_sharing_pict_0001.png'
import item02 from '../image/muscle_sharing_pict_0002.png'
import item03 from '../image/muscle_sharing_pict_0003.png'
import item04 from '../image/muscle_sharing_pict_0004.png'
import item05 from '../image/muscle_sharing_pict_0005.png'
import item06 from '../image/muscle_sharing_pict_0006.png'
import item07 from '../image/muscle_sharing_pict_0007.png'
import item08 from '../image/muscle_sharing_pict_0008.png'
import item09 from '../image/muscle_sharing_pict_0009.png'
import item10 from '../image/muscle_sharing_pict_0010.png'
import item11 from '../image/muscle_sharing_pict_0011.png'

type Items = {
  [key: string]: string
}

export const itemNameList = [
  'item01',
  'item02',
  'item03',
  'item04',
  'item05',
  'item06',
  'item07',
  'item08',
  'item09',
  'item10',
  'item11',
]

const itemList: Items = {
  item01: item01,
  item02: item02,
  item03: item03,
  item04: item04,
  item05: item05,
  item06: item06,
  item07: item07,
  item08: item08,
  item09: item09,
  item10: item10,
  item11: item11,
}

export const getItemFile = (name: string): string => {
  return itemList[name]
}
